import { render } from "./SimpleBanner.vue?vue&type=template&id=3fb1fb2a"
import script from "./SimpleBanner.vue?vue&type=script&lang=js"
export * from "./SimpleBanner.vue?vue&type=script&lang=js"

import "./SimpleBanner.vue?vue&type=style&index=0&id=3fb1fb2a&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__